// App icon badge (the little red unread count, like Mail) via the Badging API.
// Works on installed PWAs: iOS 16.4+ (notifications enabled), Chrome/Edge on
// Android + desktop. No-ops silently where unsupported.
//
// Page-side only sets the badge while the app is open; the service worker's push
// handler keeps it live when the app is closed (see public/service-worker.js).
const API = process.env.REACT_APP_API_URL || '';

export function setAppBadge(n) {
  try {
    if (!('setAppBadge' in navigator)) return;
    if (n > 0) navigator.setAppBadge(n);
    else navigator.clearAppBadge();
  } catch { /* not supported / not installed */ }
}

export function clearBadge() {
  try { if ('clearAppBadge' in navigator) navigator.clearAppBadge(); } catch {}
}

// Pull the authoritative unread count and apply it. Called on launch and whenever
// the app regains focus, so the badge self-corrects across devices.
export async function syncBadge() {
  try {
    if (!('setAppBadge' in navigator)) return;
    const r = await fetch(`${API}/api/notifications?limit=1`, { credentials: 'include' });
    if (!r.ok) return;
    const d = await r.json();
    setAppBadge(d.unread || 0);
  } catch {}
}
